export default __webpack_public_path__ + "alberta-storage-aids.a82d1eb9377108faed4b.svg";